import React, { Component } from "react";
import DownloadIcon from '@mui/icons-material/CloudDownloadRounded';
export default class UserDocumentsGridActionsRenderer extends Component {

    invokeParentMethod = () => this.props.context.componentParent.methodFromParent(`Row: ${this.props.node.rowIndex}, Col: ${this.props.colDef.headerName}`);

    handleDownloadClick = () => {
        this.props.context.componentParent.handleDownloadClick(this.props.node.id);
    }
    handleDeleteClick = () => this.props.context.componentParent.handleDeleteClick(this.props.node.id);

    render() {
        return (
            <span title='Download'>
                <DownloadIcon id='downloadDocumentButton' onClick={this.props.handleDownloadClick} />
            </span>
        );
    }
};